// extracted by mini-css-extract-plugin
export var bigger = "s_bB";
export var icon = "s_bv";
export var icons = "s_by";
export var link = "s_bs";
export var noMobile = "s_bz";
export var scrolled = "s_y";